function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="40" height="40" viewBox="0 0 40 40" {...props}><g fill="none" fillRule="evenodd"><path d="M0 40h40V0H0z" /><path fill="#7F8FA4" d="M20.7 20L31.86 8.85a.5.5 0 1 0-.7-.7L20 19.29 8.85 8.15a.5.5 0 0 0-.7.7L19.29 20 8.15 31.15a.5.5 0 0 0 .35.85.5.5 0 0 0 .35-.15L20 20.71l11.15 11.14a.5.5 0 0 0 .7 0 .5.5 0 0 0 0-.7L20.71 20z" /></g></svg>;
});


// WEBPACK FOOTER //
// ./media/svg/close.svg